import React from 'react';

import {
  createConsoleLogger,
  ConfigCatProvider as Provider,
  PollingMode,
  LogLevel,
} from 'configcat-react';

import config from 'config';
import { setApplicationVersion } from 'core/utilities';
import { INITIAL_STATE_APP_VERSION } from 'core/use-cases/version/slice/initial-state';

export const ConfigCatProvider = ({ children }: { children?: React.ReactNode }): JSX.Element => {
  const configcatLogger = createConsoleLogger(LogLevel['Off']);

  setApplicationVersion(config?.app?.version || INITIAL_STATE_APP_VERSION);

  const setLocalStorage = (key: string, value: any) => {
    window.localStorage.setItem(key, JSON.stringify(value));
  };

  const getLocalStorage = (key: string) => {
    try {
      const cacheData = window.localStorage.getItem(key);
      return JSON.parse(String(cacheData));
    } catch (error) {
      return null;
    }
  };

  return (
    <Provider
      sdkKey={config.configCat.sdkKey}
      pollingMode={PollingMode.AutoPoll}
      options={{
        cache: {
          set: setLocalStorage,
          get: getLocalStorage,
        },
        logger: configcatLogger,
        pollIntervalSeconds: 10 * 60, // 10 min
      }}
    >
      {children}
    </Provider>
  );
};
